module.exports = __webpack_public_path__ + "static/media/rsz_1banner_slider2.3c802248.jpg";